import { render, staticRenderFns } from "./XFabric.vue?vue&type=template&id=47c2d3c2&scoped=true"
import script from "./XFabric.vue?vue&type=script&lang=js"
export * from "./XFabric.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c2d3c2",
  null
  
)

export default component.exports